import { Theme } from '@radix-ui/themes';
import { forwardRef, type ReactNode } from 'react';

export type RadixThemeProviderProps = {
  appearance?: 'light' | 'dark';
  children: ReactNode;
};

export const RadixThemeProvider = forwardRef<HTMLDivElement, RadixThemeProviderProps>(
  ({ appearance = 'light', children }, ref) => (
    <Theme accentColor="cyan" grayColor="gray" appearance={appearance} className="radix-theme-provider">
      <div className="theme-root-div" ref={ref}>
        {children}
      </div>
    </Theme>
  )
);

RadixThemeProvider.displayName = 'RadixThemeProvider';
